import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Ticker from "../components/Ticker";
import { Construction, ArrowRight } from "lucide-react";

/**
 * Shared placeholder page used for every "coming soon" section — Desk,
 * Subscribe, Wire, Masthead sub-pages, etc. Same shell as the rest of the
 * site so navigation and design stay consistent; the body slot is filled by
 * the caller with a short pitch + optional action link.
 */
export const PlaceholderPage = ({
  eyebrow,
  title,
  body,
  actionLabel,
  actionHref,
  extra,
  testid,
}) => {
  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <Header />
      <Ticker />
      <main
        className="max-w-[900px] mx-auto px-6 py-16 md:py-24"
        data-testid={testid || "placeholder-page"}
      >
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#0891B2] font-condensed font-bold flex items-center gap-1.5">
          <Construction className="w-3.5 h-3.5" /> {eyebrow || "In Development"}
        </div>
        <h1 className="mt-3 font-condensed uppercase text-[38px] md:text-[52px] leading-[1.02] font-bold text-[#0B1F33] tracking-tight">
          {title}
        </h1>
        <div className="mt-3 h-[3px] w-[64px] bg-[#B8E9F1]" />
        <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-neutral-700 max-w-[640px]">
          {typeof body === "string" ? <p>{body}</p> : body}
        </div>
        {actionHref && (
          <Link
            to={actionHref}
            className="mt-8 inline-flex items-center gap-2 bg-[#0B1F33] hover:bg-[#132f57] text-[#FFFFFF] font-condensed uppercase tracking-[0.18em] text-[12px] font-bold px-5 py-3 transition-colors"
            data-testid="placeholder-cta"
          >
            {actionLabel || "Learn More"} <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        )}
        {extra}
      </main>
      <Footer />
    </div>
  );
};

export default PlaceholderPage;
